module.exports = __webpack_public_path__ + "9754856a18c583beda509ce0632fe57c.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/main/assets/images/header-image.jpg
 ** module id = 9
 ** module chunks = 0
 **/